import { baseApi } from 'components/constants/Constants';
import { request } from '../api';

export const updateUserProfile = (body, handleSuccess, handleError) => {
  const options = {
    method: 'PUT',
    url: `${baseApi}/users/profile`,
    headers: { 'Content-Type': 'application/json' },
    data: body
  };
  const toastOptions = {
    pending: 'Saving changes',
    success: 'Data updated successfully'
  };

  request(options, handleSuccess, handleError, toastOptions);
};
//  Get User's Preferences

// export const getUserPreferences = (userID, success, handleError) => {
//   const options = {
//     method: 'GET',
//     url: `${baseApi}/users/${userID}/preferences`,
//     headers: { 'Content-Type': 'application/json' }
//   };

//   request(options, success, handleError);
// };

//  Update User's Preferences

export const updateUserPreferences = (data, success, handleError) => {
  const options = {
    method: 'PUT',
    url: `${baseApi}/users/settings/preferences`,
    headers: { 'Content-Type': 'application/json' },
    data: data
  };

  request(options, success, handleError);
};

//  Create User's Preferences at first time visiting preferences

export const createUserPreferences = (data, success, handleError) => {
  const options = {
    method: 'PUT',
    url: `${baseApi}/users/settings/preferences`,
    headers: { 'Content-Type': 'application/json' },
    data: data
  };

  request(options, success, handleError);
};

export const getLanguages = (searchValue, success, handleError) => {
  const query = searchValue ? '?name__icontains=' + searchValue : '';
  const options = {
    method: 'GET',
    url: `${baseApi}/reference/data/languages${query}`,
    headers: { 'Content-Type': 'application/json' }
  };
  request(options, success, handleError);
};

export const getEventUserPreferences = (eventKey, success, handleError) => {
  const options = {
    method: 'GET',
    url: `${baseApi}/events/${eventKey}/users/preferences`,
    headers: { 'Content-Type': 'application/json' }
  };
  request(options, success, handleError);
};
export const updateEventUserPreferences = (
  eventKey,
  data,
  success,
  handleError
) => {
  const options = {
    method: 'PUT',
    url: `${baseApi}/events/${eventKey}/users/preferences`,
    headers: { 'Content-Type': 'application/json' },
    data: data
  };
  request(options, success, handleError);
};
